import { TopSection } from "src/components/_pages/facility-overview/top-section";
import { AboutSection } from "src/components/_pages/facility-overview/about-section";
import { CommitmentSection } from "src/components/_pages/facility-overview/commitment-section";
import { RoomSection } from "src/components/_pages/facility-overview/room-section";
import { BasicSection } from "src/components/_pages/facility-overview/basic-section";
import { FacilitySection } from "src/components/_pages/home/facility-section";
import { Footer } from "src/components/footer";

const FacilityOverview = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | Facility Overview</title>
      <article>
        <TopSection />
        <AboutSection />
        <CommitmentSection />
        <RoomSection />
        <FacilitySection />
        <BasicSection />
        <Footer />
      </article>
    </>
  );
};

export default FacilityOverview;
